import { Moment } from "moment"
import { useRouteMatch } from "react-router-dom"
import { createDate } from "utils/createDate"
import { PlanningRouteParams } from "./types"

interface IUseGetDateByPlanningRouteReturn {
  date: Moment
  params: PlanningRouteParams
}

export function useGetDateByPlanningRoute(): IUseGetDateByPlanningRouteReturn {
  const { params } = useRouteMatch<PlanningRouteParams>()
  const date = createDate({ ...params, weekday: params.weekday || 1 })
  return {
    date,
    params,
  }
}

export function useGetPlanningSwitchNavigation() {
  const {
    params: { year, week },
  } = useGetDateByPlanningRoute()

  const planningSwitchNavigation = [
    {
      to: `/planning/${year}/${week}`,
      label: "switch.workstations",
      key: "planning-workstations",
    },
    {
      to: `/planning/functions/${year}/${week}`,
      label: "switch.employees",
      key: "planning-employees",
    },
  ]

  return planningSwitchNavigation
}
